import { UserRole } from '@wineryxplorer/shared';

const ROLE_STYLES: Record<string, string> = {
  [UserRole.USER]: 'bg-gray-100 text-gray-700',
  [UserRole.VENUE_ADMIN]: 'bg-primary-100 text-primary-700',
  [UserRole.SITE_ADMIN]: 'bg-primary-100 text-primary-700',
  [UserRole.SUPER_ADMIN]: 'bg-red-100 text-red-700',
};

interface RoleBadgeProps {
  role: UserRole;
  size?: 'sm' | 'lg';
}

export const RoleBadge = ({ role, size = 'sm' }: RoleBadgeProps) => (
  <span
    className={`inline-flex items-center rounded font-medium ${ROLE_STYLES[role] || 'bg-gray-100 text-gray-700'} ${
      size === 'lg' ? 'px-3 py-1 text-sm' : 'px-2 py-0.5 text-xs'
    }`}
  >
    {role.replace('_', ' ')}
  </span>
);

const AVATAR_BOX = {
  sm: 'h-8 w-8',
  lg: 'h-16 w-16',
} as const;

const AVATAR_FALLBACK = {
  sm: 'bg-gray-200 flex items-center justify-center text-sm font-medium text-gray-600',
  lg: 'bg-primary-600 flex items-center justify-center text-xl font-semibold text-white',
} as const;

interface UserAvatarProps {
  name?: string;
  image?: string;
  avatar?: string;
  size?: 'sm' | 'lg';
}

export const UserAvatar = ({ name, image, avatar, size = 'sm' }: UserAvatarProps) => {
  const src = avatar || image;
  if (src) {
    return (
      <img
        src={src}
        alt={name || 'User'}
        className={`${AVATAR_BOX[size]} rounded-full object-cover`}
      />
    );
  }
  const initial = (name || '?')[0].toUpperCase();
  return (
    <div className={`${AVATAR_BOX[size]} rounded-full ${AVATAR_FALLBACK[size]}`}>{initial}</div>
  );
};
